export default __webpack_public_path__ + "static/media/promos-icon-active.a7603bf9.webp";